import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { TssCacheProvider } from 'tss-react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FilterInquiryProvider } from './hooks/useFilterInquiry';
import history from 'utils/history';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/lightTheme.scss';

import { AppConfig } from 'components';

import theme from './theme';
//import { configureStore } from './store';
import { ScrollReset, GoogleAnalytics, CookiesNotification } from './components';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/index.scss';

import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/pt-br';

moment.locale('pt-br');

import { store, persistor } from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import TermsOfUseGuard from 'components/TermsOfUseGuard/TermsOfUseGuard';

Chart.plugins.unregister(ChartDataLabels);

const muiCache = createCache({ key: 'mui', prepend: true });
const tssCache = createCache({ key: 'tss' });

//const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CacheProvider value={muiCache}>
          <TssCacheProvider value={tssCache}>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
                <Router basename={process.env.PUBLIC_URL || ''} history={history}>
                  <ScrollReset />
                  <GoogleAnalytics />
                  <CookiesNotification />
                  <AppConfig />
                  <FilterInquiryProvider>
                    <TermsOfUseGuard />
                  </FilterInquiryProvider>
                </Router>
                {/* <FilterInquiryProvider>
              <RoutersApp />
            </FilterInquiryProvider> */}
              </LocalizationProvider>
            </ThemeProvider>
          </TssCacheProvider>
        </CacheProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
